<script>
  import {
    openSystemTooltip,
    closeSystemTooltip,
  } from "../../editor/utility.js";
  import {
    unlockedSpecs,
    updateUnlockedSpecs,
    systemLog,
    soloUnlock,
    setSoloUnlock,
    clearSoloUnlock,
    unlockedSpecsMemory,
    setUnlockedSpecsMemory,
    currentSpec,
    wasmLoaded,
    pyodide,
  } from "../../editor/storage.js";
  import {
    setExplorationMode,
    explorationTarget,
    clearExplorationMode,
    explorationKeys,
    explorationMode,
  } from "../../editor/exploration/exploration.js";
  export let clickFunction;
  // recommender
  function runRecommender(mode, uid) {
    setSolo(uid);
    setExplorationMode(mode, uid);
    $systemLog.log({ message: "Run " + mode, artboard_uid: uid });
    // viewVersions = false;
    // viewHistory = false;
  }
  function closeRecommender(uid) {
    unsetSolo();
    clearExplorationMode("f");
    $systemLog.log({ message: "Close exploration", artboard_uid: uid });
  }
  function unsetSolo() {
    // there's existing solo-unlock
    let old_uid = $soloUnlock;
    clearSoloUnlock();
    updateUnlockedSpecs($unlockedSpecsMemory);
    $systemLog.log({ message: "Unset solo", artboard_uid: old_uid });
  }
  function setSolo(uid) {
    if ($soloUnlock === undefined) {
      // nothing is solo-unlocked
      setSoloUnlock(uid);
      setUnlockedSpecsMemory($unlockedSpecs);
      updateUnlockedSpecs([uid]);
      $systemLog.log({ message: "Set solo", artboard_uid: uid });
    } else if ($soloUnlock !== undefined && $soloUnlock !== uid) {
      // there's existing solo-unlock
      setSoloUnlock(uid);
      updateUnlockedSpecs([uid]);
      $systemLog.log({ message: "Set solo", artboard_uid: uid });
    }
  }
</script>

<button
  class={"icon-menu exploration"}
  type="button"
  aria-roledescription="Explore responsive designs"
  disabled={$currentSpec?.is_first || !($wasmLoaded.clingo && $wasmLoaded.pyodide)}
  on:click={(event) => {
    clickFunction(event, undefined);
    // run exploration
    if (
      $explorationTarget === $currentSpec.uid &&
      $explorationMode === explorationKeys.EXPLORATION
    ) {
      closeRecommender($currentSpec.uid);
    } else if (
      $explorationTarget === $currentSpec.uid &&
      $explorationMode !== undefined
    ) {
      runRecommender(explorationKeys.EXPLORATION, $currentSpec.uid);
    } else {
      runRecommender(explorationKeys.EXPLORATION, $currentSpec.uid);
    }
  }}
  on:mouseover={function (event) {
    openSystemTooltip(event, this.getAttribute("aria-roledescription"));
  }}
  on:mousemove={function (event) {
    openSystemTooltip(event, this.getAttribute("aria-roledescription"));
  }}
  on:focus={() => closeSystemTooltip()}
  on:blur={() => closeSystemTooltip()}
  on:mouseout={() => closeSystemTooltip()}
>
  <i class="bi bi-magic" />
</button>

<style>
  .icon-menu.exploration[disabled] {
    opacity: 0.3;
  }
  .icon-menu.exploration,
  .icon-menu.exploration:hover {
    background-color: #005996 !important;
  }
  .icon-menu.exploration i {
    color: white !important;
  }
</style>
